import { OPEN, CLOSE } from './types';
import React from 'react';
import PreviewModal from 'components/modals/PreviewModal';
import RemoveFeed from 'components/modals/RemoveFeed';
import RemoveGroup from 'components/modals/RemoveGroup';
import FeedPreview from 'components/modals/FeedPreview';

export function close() {
    return (dispatch) =>
        dispatch({
            type: CLOSE,
        });
}

export const openFeedPreviewModal = (getPreview) => {
    return (dispatch) =>
        dispatch({
            type: OPEN,
            component: <PreviewModal getPreview={getPreview} />,
        });
};

export const deleteFeed = (feed, callback) => {
    return (dispatch) =>
        dispatch({
            type: OPEN,
            component: <RemoveFeed callbackFunc={callback} feed={feed} />,
        });
};

export const deleteGroup = (group, callback) => {
    return (dispatch) =>
        dispatch({
            type: OPEN,
            component: <RemoveGroup callbackFunc={callback} group={group} />,
        });
};

export const openFeedPreview = (feed, getFeedsList, modalType) => {
    return (dispatch) =>
        dispatch({
            type: OPEN,
            component: <FeedPreview feed={feed} getFeedsList={getFeedsList} modalType={modalType} />,
        });
};